import { useQuery } from "@tanstack/react-query";
import React from "react";
import { Helmet } from "react-helmet";
import Footer from "../components/footer";
import Header from "../components/header";
import PoliciesReportCard from "../components/policiesReportCard";
import Spinner from "../components/spinner";
import TableOfContents from "../components/table-of-contents";
import TopNavabr from "../components/topNavabr";
import { BASE_URL, IMAGE_BASE_URL } from "../data/baseURL";
import { sustainabilitySubMenu } from "../data/sustainble-submenu";
import { useScrollTop } from "../hook/useScrollTop";
import CreatingSustainableValue from "../sections/creating-sustainable-value";
import DrivingBusinessExcellenceAndEfficiency from "../sections/driving-business-excellence-and-efficiency";
import Governance from "../sections/governance";

const Sustainability = () => {
  const { data, isLoading } = useQuery(["sustainability"], async () => {
    const response = await window.fetch(`${BASE_URL}/sustainability`);
    return await response.json();
  });

  useScrollTop();

  if (isLoading) {
    return <Spinner />;
  }

  const {
    sustainability_banner,
    sustainability_driving,
    sustainability_sustainable,
    sustainability_governance,
    sustainability_material,
    sustainability_image,
    sustainability_proposition,
  } = data?.sustainability ?? {};
  return (
    <>
      <Helmet>
        <title>AFRO || Sustainability</title>
      </Helmet>
      <TopNavabr />
      <Header
        bannerBackground={
          Boolean(sustainability_banner?.default) ? "video" : "image"
        }
        videoURL={sustainability_banner?.video}
        imageURL={sustainability_banner?.image}
      >
        <div className="pt-7 pb-5 text-center">
          <h1 className="fs-56 mt-4 text-capitalize flex align-items-center header-background-image-size">
            {sustainability_banner.title}
          </h1>
        </div>
      </Header>
      <section className="pb-7">
        <section className="d-none d-lg-block">
          <ul className="d-flex justify-content-around text-center bg-light fs-14 list-style-none m-0 p-0 align-items-stretch">
            {sustainabilitySubMenu.map((menu) => (
              <li
                key={menu.id}
                className="border-gray submenu-link d-block w-100 d-flex justify-content-center align-items-center"
              >
                <a
                  href={menu.link}
                  className="text-decoration-none fs-16 gilroy-bold d-block w-100 py-3"
                >
                  {menu.label}
                </a>
              </li>
            ))}
          </ul>
        </section>
        <TableOfContents routes={sustainabilitySubMenu} />
        <section className="container-fluid">
          <section className="ms-47 me-47 mt-7">
            <div id="our-proposition">
              {sustainability_material?.map((data, index) => (
                <div key={index} className={`${index > 0 ? "pt-7" : ""}`}>
                  <h1 className="pb-5">
                    <img
                      src={`${IMAGE_BASE_URL}/${data?.image}`}
                      height={45}
                      width={50}
                      alt=""
                    />{" "}
                    <span className="fs-38 lh-40 gilroy-bold text-capitalize">
                      {data?.title}
                    </span>
                  </h1>
                  {data?.key_material?.map((data, index) => (
                    <PoliciesReportCard
                      key={index}
                      data={data}
                      index={index}
                      downloadURL="key-material-download"
                    />
                  ))}
                </div>
              ))}
            </div>
            <hr />
            <DrivingBusinessExcellenceAndEfficiency
              sustainability_driving={sustainability_driving}
            />
            <hr />
            <CreatingSustainableValue
              sustainability_sustainable={sustainability_sustainable}
            />
            <hr />
            <Governance sustainability_governance={sustainability_governance} />
          </section>
        </section>
      </section>
      <Footer />
    </>
  );
};

export default Sustainability;
